import { useState } from 'react'
import { UserLoginForm, ForgotPasswordForm, PhoneLoginForm } from 'components/forms/user_login'
import { Gauge, Headphones, ShieldCheck, Zap } from 'lucide-react'
import Aos from 'aos'

const FEATURES = [
    { icon: Zap, label: 'Instant Recharge' },
    { icon: Gauge, label: 'Live Usage' },
    { icon: Headphones, label: '24x7 Support' },
    { icon: ShieldCheck, label: 'Secure Payments' },
]

// Glowing "fibre" routes drawn over the night-earth photo (city lights = network nodes)
const ROUTES = [
    'M-50,620 C250,420 520,460 760,300',
    'M120,900 C300,640 620,700 900,520',
    'M-80,380 C200,300 420,180 700,160',
    'M300,960 C420,760 520,620 760,300',
]
const NODES = [[760, 300], [900, 520], [700, 160], [420, 470], [240, 560]]

export default function UserLogin() {

    Aos.init();
    // login | forgot | phone (portal: Login, Forgot Password, Login Via Phone No.)
    const [mode, setMode] = useState('login')
    const setTogggle = (v) => setMode(v ? 'forgot' : 'login')

    return (
        <div className="lx_page">
            <div className="lx_bg" />
            <div className="lx_shade" />

            <svg className="lx_net" viewBox="0 0 1000 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
                <defs>
                    <linearGradient id="lxRoute" x1="0" x2="1">
                        <stop offset="0%" stopColor="#2bb8c5" stopOpacity="0" />
                        <stop offset="60%" stopColor="#2bb8c5" stopOpacity=".9" />
                        <stop offset="100%" stopColor="#bff6fb" />
                    </linearGradient>
                </defs>
                {ROUTES.map((d, i) => (
                    <g key={i}>
                        <path d={d} className="lx_route" />
                        <path d={d} className="lx_pulse" style={{ animationDelay: `${i * 1.1}s` }} />
                    </g>
                ))}
                {NODES.map(([x, y], i) => (
                    <g key={i} className="lx_node" style={{ animationDelay: `${i * .6}s` }}>
                        <circle cx={x} cy={y} r="14" />
                        <circle cx={x} cy={y} r="4" />
                    </g>
                ))}
            </svg>

            <div className="lx_content">
                {/* Hero copy */}
                <div className="lx_hero" data-aos="fade-right" data-aos-duration="1000">
                    <span className="lx_eyebrow"><span className="lx_live" /> Ethernet Xpress · Customer Portal</span>
                    <h1>Amazingly<br /><span>fast.</span> Always on.</h1>
                    <p>Recharge, track your data usage and get support. Your whole broadband account in one place.</p>
                    <div className="lx_chips">
                        {FEATURES.map(({ icon: Icon, label }) => (
                            <span key={label} className="lx_chip"><Icon size={15} /> {label}</span>
                        ))}
                    </div>
                </div>

                {/* Form */}
                <div className="lx_form" data-aos="zoom-in" data-aos-duration="800" key={mode}>
                    {mode === 'login' && <UserLoginForm setTogggle={setTogggle} onPhoneLogin={() => setMode('phone')} />}
                    {mode === 'forgot' && <ForgotPasswordForm setTogggle={setTogggle} />}
                    {mode === 'phone' && <PhoneLoginForm onBack={() => setMode('login')} />}
                </div>
            </div>

            <div className="lx_foot">© {new Date().getFullYear()} Ethernet Xpress. All rights reserved.</div>
        </div>
    )
}
